import BaseTimeline from '../base-timeline';
import { IAnimCompleteParams, IAnimStartParams, ITimelineParams } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/anim-interface';
import { isIframeShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { setPointerEvents } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/anim-utils';
import { AnimCanvasProperty, POINTER, ATTR_LIST, Action } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/anim-constants';
import { presetClassTypes } from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';
import { getTargetComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/anim-component-relate';
import { IAnimModel } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import Animation from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/brevity/animation';


export default class EditorAnimTimeline extends BaseTimeline {
    public constructor({ animList, slideComponent, mediaManager,
        options, playManager }: ITimelineParams) {
        super({ animList, slideComponent, mediaManager, options, playManager });
        this.masterTimeline = this.getMasterTimeline(animList, slideComponent);
    }
    protected handleAnimStart(params: IAnimStartParams): void {
        setPointerEvents(params.animTarget, POINTER.NONE);
        super.handleAnimStart(params);
    }

    protected handleAnimComplete(params: IAnimCompleteParams): void {
        const { animTarget, animModel } = params;
        setPointerEvents(animTarget, POINTER.AUTO);
        super.handleAnimComplete(params);
        // 预览态动画，在masterTL结束时需要重置为元素的初始状态，需要重新渲染
        const { factoryOptions } = animTarget;
        const needUpdateFontList = [AnimCanvasProperty.FONT_COLOR, AnimCanvasProperty.FONT_SIZE];
        factoryOptions.anim = {
            needUpdateFont: needUpdateFontList.some(prop => params.fromStyle[prop]),
        };
        // 预览态下音视频处于选中态，播放完动画，需要显示dom元素，隐藏canvas元素
        const elementModel = animTarget?.factoryOptions?.model;
        if (isIframeShapeModel(elementModel)) {
            this.mediaManager.changeIframeDisplayState(true);
        }

        if (animModel?.props?.presetClass === presetClassTypes.EXIT) {
            animTarget.visible = false;
        }
    }

    /**
     * 总时间线onComplete回调，编辑态下，一组动画播放完之后，需要恢复到动画开始前的初始样式
     * @param animsOrderMap 播放顺序与动画的映射对象，该映射对象的value是一个二维数组
     * order => [[clickEffectAnim, withEffectAnim], [afterEffectAnim]， [afterEffectAnim]]
     */
    protected handleMasterComplete(animsOrderMap: Map<number, IAnimModel[][]>): void {
        this.options.editorAnimPreviewManager.isAnimPreviewing = false;
        animsOrderMap.forEach((animList) => {
            animList.forEach((animEffectList) => {
                animEffectList.forEach((animModel: IAnimModel) => {
                    const animTargetKey = animModel?.elementModel?.key;
                    if (!animTargetKey) return;
                    const animTarget = getTargetComponent(animTargetKey, this.slideComponent);
                    if (!animTarget) return;
                    const animFilterType = this.animFiltersManager?.getAnimFilterType(animModel.props.animType);
                    if (animFilterType && animModel.props.presetClass === presetClassTypes.EXIT) {
                        this.animFiltersManager
                            .handleAnimFiltersComplete(
                                animFilterType,
                                animTarget,
                                animModel.props.presetClass as Action,
                                true,
                            );
                    }
                    const originalStyle = this.originalStyleMap.get(animTargetKey);
                    Animation.set(animTarget, originalStyle);
                    animTarget.factoryOptions.anim = {
                        needUpdateFont: [
                            AnimCanvasProperty.FONT_COLOR,
                            AnimCanvasProperty.FONT_SIZE,
                        ].some(key => animTarget[key]),
                    };

                    if (ATTR_LIST.some(key => animTarget[key])) {
                        animTarget.factoryUpdateComponent();
                    }
                    ATTR_LIST.forEach((attr) => {
                        Reflect.deleteProperty(animTarget, attr);
                    });
                });
            });
        });
        this.resumeAutoRender();
        this.lastStyleMap = new Map();
        this.differentPropertyMap = new Map();
        this.tempStyleMap = new Map();
    }
}
